import { getMentionValue, MENTION_END_CHAR_REGEX, MENTION_TRIGGER } from '../Markdown/mentionUtils';
/**
 * Finds all mentions in a given text string.
 * A mention starts with the MENTION_TRIGGER (@) character and is followed by valid mention content.
 * The mention must be preceded by whitespace, start of string, or certain punctuation characters.
 *
 * @param text - The text to search for mentions
 * @returns Array of mention matches with start/end positions and text content
 */
export function findMentions(text) {
    const mentions = [];
    for (let i = 0; i < text.length; i++) {
        // Look for the trigger character
        if (text[i] === MENTION_TRIGGER &&
            (i === 0 || /\s/.test(text[i - 1]) || MENTION_END_CHAR_REGEX.test(text[i - 1]))) {
            const start = i;
            const { value, endIndex } = getMentionValue(text, i + 1);
            const mentionValue = MENTION_TRIGGER + value;
            // If we found a valid mention (more than just the @ symbol)
            if (mentionValue.length > 1) {
                mentions.push({
                    start,
                    end: endIndex,
                    text: mentionValue
                });
                // Move i to the end of the mention - 1 (the loop will increment i)
                i = endIndex - 1;
            }
        }
    }
    return mentions;
}
export function processTextWithMentions(text) {
    const mentions = findMentions(text);
    if (mentions.length === 0) {
        return [{ text, isMention: false }];
    }
    const segments = [];
    let lastIndex = 0;
    mentions.forEach((mention) => {
        // Add text before the mention
        if (mention.start > lastIndex) {
            segments.push({
                text: text.slice(lastIndex, mention.start),
                isMention: false
            });
        }
        // Add the mention segment
        segments.push({
            text: mention.text,
            isMention: true,
            mentionValue: mention.text
        });
        lastIndex = mention.end;
    });
    // Add any remaining text after the last mention
    if (lastIndex < text.length) {
        segments.push({
            text: text.slice(lastIndex),
            isMention: false
        });
    }
    return segments;
}
// Re-export the existing utilities for convenience
export { getMentionValue, MENTION_END_CHAR_REGEX, MENTION_TRIGGER, MENTION_PROPERTIES_SEPARATOR, parseMentionWithProperties, enrichMentionWithProperties } from '../Markdown/mentionUtils';
